import { CurrentPayPlan, FlowType, MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import { NewJoinSessionData, ProductType, RoleType } from '../application/models/NewJoinSessionData';
import { FlowContentName, getFlowContent } from './getFlowContent';
import { benefitsHelper } from './benefitsHelper';

export class stringHelper {
  static formatMoney(value: string): string {
    let numericValue: number = parseFloat(value); // Convert string to number
    if (Number.isNaN(numericValue)) {
      return '';
    }
    let formattedString: string = numericValue.toFixed(2); // Format with two decimal places
    return `$${formattedString}`;
  }

  static getKeyFromEnum(targetEnum: object, key: string): string {
    return Object.keys(targetEnum)[Object.values(targetEnum).indexOf(key)];
  }
}

export const promotionalLabelMap = {
  [MembershipLevel.CLASSIC]: 'Essential',
  [MembershipLevel.CLASSIC_RV]: 'Essential',
  [MembershipLevel.PLUS]: 'Best value',
  [MembershipLevel.PLUS_RV]: 'Best value',
  [MembershipLevel.PREMIER]: 'Most exclusive',
  [MembershipLevel.PREMIER_RV]: 'Most exclusive',
};

export const benefitListTitleMap = {
  [MembershipLevel.CLASSIC]: 'Essential benefits for the road and beyond',
  [MembershipLevel.CLASSIC_RV]: 'Essential benefits for the road and beyond',
  [MembershipLevel.PLUS]: 'All the benefits of Classic, and:',
  [MembershipLevel.PLUS_RV]: 'All the benefits of Classic, and:',
  [MembershipLevel.PREMIER]: 'All the benefits of Classic and Plus, and:',
  [MembershipLevel.PREMIER_RV]: 'All the benefits of Classic and Plus, and:',
};

export const getMembershipTitle = (membershipLevel: MembershipLevel) => {
  switch (membershipLevel) {
    case MembershipLevel.CLASSIC:
      return 'Classic';
    case MembershipLevel.PLUS:
      return 'Plus';
    case MembershipLevel.PREMIER:
      return 'Premier';
    default:
      return '';
  }
};

export const getRecurringPeriodLabel = (
  sessionData: NewJoinSessionData,
  isMonthlySelected?: boolean,
  discountAppliedFromMembershipInfo?: boolean
) => {
  const discountApplied = benefitsHelper.discountApplied(sessionData?.priceCart) || discountAppliedFromMembershipInfo;
  const ERSApplied =
    benefitsHelper.ERSApplied(sessionData?.priceCart) || sessionData.formData.products?.includes(ProductType.ERS);

  //MDO
  if (
    //switching mdo/ado on landing page
    isMonthlySelected ||
    (isMonthlySelected === undefined && sessionData.formData.billPlan === CurrentPayPlan.RECURRINGMONTHLY)
  ) {
    return getFlowContent(FlowContentName.MDOLabel, sessionData.flowType, sessionData.clubCode!);
  } else if (sessionData.flowType !== FlowType.EMPLOYEE && (discountApplied || ERSApplied)) {
    return getFlowContent(FlowContentName.ADODiscountedLabel, sessionData.flowType, sessionData.clubCode!);
  } else {
    return getFlowContent(FlowContentName.ADOLabel, sessionData.flowType, sessionData.clubCode!);
  }
};

export const getAddressPageTitle = (isGiftFlow: boolean, isGettingResidenceAddress: boolean) => {
  if (isGiftFlow) {
    if (isGettingResidenceAddress) {
      return `What is the recipient's home address?`;
    }
    return `What is the recipient's mailing address?`;
  } else if (isGettingResidenceAddress) {
    return `What is your home address?`;
  } else {
    return `What is your mailing address?`;
  }
};

export const formatMembershipNumber = (membershipNumber: string) => {
  const match = membershipNumber.match(/^(\d{3})(\d{3})(\d{10})$/);
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  }
  return membershipNumber;
};

export const associateTypeMap = {
  [RoleType.ADULT_ASSOCIATE]: 'Adult',
  [RoleType.ASSOCIATE]: 'Associate',
  [RoleType.DEPENDENT]: 'Dependent',
  [RoleType.PRIMARY]: 'Primary',
};

export const promotionMap: Record<
  string,
  { text: string; color: string; backgroundColor: string; shortText?: string }
> = {
  //the shortened text is to display differently on Premier level, might be removed if UI decide to show full text in the future
  [MembershipLevel.CLASSIC]: {
    text: 'Essential',
    color: '#0156A3',
    backgroundColor: '#F5F7FA',
    shortText: 'Essential',
  },
  [MembershipLevel.CLASSIC_RV]: {
    text: 'Essential',
    color: '#0156A3',
    backgroundColor: '#F5F7FA',
    shortText: 'Essential',
  },
  [MembershipLevel.PLUS]: { text: 'Best value', color: '#7527B9', backgroundColor: '#FAF5FF', shortText: 'Best value' },
  [MembershipLevel.PLUS_RV]: {
    text: 'Best value',
    color: '#7527B9',
    backgroundColor: '#FAF5FF',
    shortText: 'Best value',
  },
  [MembershipLevel.PREMIER]: {
    text: 'Most exclusive',
    color: '#3E6B20',
    backgroundColor: '#F3FBEA',
    shortText: 'Exclusive',
  },
  [MembershipLevel.PREMIER_RV]: {
    text: 'Most exclusive',
    color: '#3E6B20',
    backgroundColor: '#F3FBEA',
    shortText: 'Exclusive',
  },
};
